import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import {
    Inject,
    Injectable
} from '@angular/core';
import {
    BehaviorSubject,
    catchError,
    concatMap,
    defaultIfEmpty,
    delay,
    finalize,
    forkJoin,
    interval,
    map,
    Observable,
    of,
    skipWhile,
    Subject,
    Subscription,
    switchMap,
    take,
    takeUntil,
    tap,
} from 'rxjs';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { SnackBarComponent } from 'app/modules/shared/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface UploadFile {
    id?: string;
    table_name?: string;
    field_name?: string;
    field_title?: string;
    file_name?: string;
    istanza_id?: string;
    file_size?: number;
    mime_type?: string;
    descrizione?: string;
    note?: string;
    stato?: string;
    firmato?: boolean;
    //file_id?: string;
    nr?: number;
    signed?: string;
    document_id?:string;

    address?: string;
    /**
     * Show progress bar
     *
     * The status of the item changes based on the value:
     * - <b>uploading</b>: if value is between 0 and 100 (exclusive 0 < value < 100)
     * - <b>success</b>: if value is greater than 100
     */
    progress?: number;
    /**
     * Show the ability to delete item
     * @default false
     */
    removable?: boolean;
    /**
     * Set the status of the item as 'error'
     */
    error?: boolean;
    error_message?: string;
    cancelled?: boolean;

    /**
     * Add tooltip on file item name
     * @example It can be used to show the error message or additional information about the file
     */
    tooltip?: string;

    file?: File;
    progress$: BehaviorSubject<number | null>;



}

export interface printParams {
    istanza_id: string; ///DA TOGLIERE????
    print_model: string;
    field_name: string;
    field_title: string;
    pdf: string;
}

  export interface FileData {
    id: string;
    file_name: string;
    mime_type: string;
    file_size: number;
  }

export interface Files{
    field_name:string;
    files:FileData[];
    field_title:string;
}

@Injectable({
    providedIn: 'root',
})
export class AllegatiService {



    private _allegati: BehaviorSubject<UploadFile[]> = new BehaviorSubject([]);

    get allegati$(): Observable<UploadFile[]> {
        return this._allegati.asObservable();
    }


    totalSize: number = 0;

    private cancelUploadSignals: Map<any, Subject<void>> = new Map(); // Mappa per i segnali di annullamento


    fileUploadError: boolean = false;

    fileUploadSuccess: boolean = false;

    uploadProgress: number;

    uploadSub: Subscription;

    onProgress$: Subject<{ fileid: string, progress: number }> = new Subject();

    constructor(
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
        private _httpClient: HttpClient,
        private _snackBar: MatSnackBar
    ) { }


    uploadFile(file: UploadFile): void {

        if (file.error){
            //li aggiungo con l'errore senza inviarli al server
            const elenco = this._allegati.value
            elenco.push(file);
            this._allegati.next(elenco);
        }
        else{

            const formData = new FormData();
            formData.append('file', file.file);
            formData.append('field_name', file.field_name.trim());
            formData.append('field_title', file.field_title);
            formData.append('document_id', file.document_id);
            formData.append('signed', file.signed);
            formData.append('id', file.id);

            const cancelSignal = new Subject<void>();
            this.cancelUploadSignals.set(file, cancelSignal);
            this._httpClient.post(`${this.backendUrls.backendApiUrl}/allegati`, formData, {
            reportProgress: true,
            observe: 'events',
            }).pipe(takeUntil(cancelSignal)).subscribe({
            next: event => {
                if (event.type === HttpEventType.UploadProgress && event.total) {
                const percentDone = Math.round((100 * event.loaded) / event.total);
                file.progress$.next(percentDone);
                } else if (event.type === HttpEventType.Response) {
                file.progress$.next(100);
                const result = event.body["data"];
                if (result){
                    const elenco = this._allegati.value
                    elenco.push(result);
                    this._allegati.next(elenco);
                }
                }
            },
            error: err => {
                file.progress$.next(null);
                file.error=true;
                if (err.status == 413){
                    file.error_message="File troppo grande, dimensione massima 50 Mb"
                }
                else{
                    file.error_message=err.error.detail;
                }
            }
            });
        }
    }


    stopUpload(allegato: UploadFile) {
        // Annulla la richiesta e aggiorna lo stato del file
        const cancelSignal = this.cancelUploadSignals.get(allegato);
        if (cancelSignal) {
          cancelSignal.next(); // Invoca il segnale di annullamento
          cancelSignal.complete();
          allegato.cancelled = true; // Segna il file come annullato
        }
    }


    getAllegati(
        istanza_id: string,
        field_name: string = ''
    ): Observable<any> {
        const params = {};
        if (field_name!=''){
            params["field_name"]=field_name;
        }
        return this._httpClient
            .get<UploadFile[]>(`${this.backendUrls.backendApiUrl}/allegati/documento/${istanza_id}`, {params: params})
            .pipe(
                map((result) => result['data']),
                tap((allegati)=>this._allegati.next(allegati)),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    console.log(err['message']);
                    return of(null);
                })
            );
    }


    deleteAllegato(allegato: UploadFile): Observable<UploadFile> {
        return this.allegati$.pipe(
            take(1),
            switchMap((allegati:any) =>
                this._httpClient
                    .delete(`${this.backendUrls.backendApiUrl}/allegati/${allegato.id}`)
                    .pipe(
                        map((result) => result['data']),
                        map((deletedAllegato: UploadFile) => {
                            // Find the index of the deleted attivita
                            const index = allegati.findIndex(
                                (item) => item.id === allegato.id
                            );
                            // Delete the attivita
                            if (index != -1) {
                                allegati.splice(index, 1);

                                // aggiorna la lista
                                this._allegati.next(allegati);
                            }
                            return deletedAllegato
                        })
                    )
            )
        );
    }

    deleteByField(istanza_id, field_name) {
        return this._httpClient
            .delete<any>(
                `${this.backendUrls.backendApiUrl}/allegati`,
                {
                    params: {
                        document_id: istanza_id,
                        field_name: field_name
                    },
                }
            )
            .pipe(
                map((response) => response['data']),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    return of(null);
                })
            )
    }

    saveFakeAllegati(fileList: UploadFile[]) {
        //fileList = this._allegati.value
        console.log(fileList);
        const uploadList$ = fileList.map((fileItem, index) => {
            fileItem.removable = false;
            console.log(fileItem);
            return interval(50).pipe(
                //Simulate upload of single file
                take(100),
                delay(index * 500),
                map((x) => x + 1), // Start from 1, end 100
                tap((progress) => {
                    this.onProgress$.next({ fileid: 'ccc', progress: progress });
                    fileItem.progress = progress;
                })
            );
        });

        forkJoin(uploadList$).subscribe();
    }


    getAllegatiByField(field_name: string) {
        return this._allegati.value[field_name]
    }

    getAllegatoById(id: string): Observable<any> {
        return this._httpClient.get(`${this.backendUrls.backendApiUrl}/allegati/${id}`, { responseType: 'blob' })
    }

    stampaDocumento(params: printParams): Observable<UploadFile> {
        return this.allegati$.pipe(
            take(1),
            defaultIfEmpty({}),
            switchMap((allegati:UploadFile[]) =>  this._httpClient.post<any>(
                `${this.backendUrls.backendApiUrl}/utils/stampa/${params.istanza_id}`,params
            ).pipe(
                map(result=>result["data"]),
                tap((allegato:UploadFile)=>{
                    //tolgo un altra stampa precedente
                    allegati = allegati.filter(item=>item.file_name!=allegato.file_name);
                    allegato.field_name=params.field_name
                    allegati.push(allegato)
                    this._allegati.next(allegati);
                })
            )),
        )
    }


    //Serviva a creare il riepilogo e inserire automaticamente tra i file
    //ORA NON USATO
    creaRiepilogo(params: printParams): Observable<UploadFile> {
        return this._httpClient
            .post<any>(
                `${this.backendUrls.backendApiUrl}/istanze/${params.istanza_id}/riepilogo`,
                {
                    print_model: params.print_model,
                    field_name: params.field_name,
                    pdf: params.pdf
                }
            )
            .pipe(
                map((result) => result['data']),
                tap((allegato) => this.onProgress$.next(allegato.progress)),
                tap((allegato)=>{
                    //this.setAllegati(allegato.field_name,[allegato])
                }),
                catchError((err: Response) => {
                    if (err.status === 200) {
                        console.log(err['message']);
                    }
                    return of(null);
                })
            )
    }

    openFile(file: UploadFile, download:boolean=false) {
        return this.getAllegatoById(file.id).pipe(
            map((blob: any) => {
                if ((window.navigator as any).msSaveBlob) {
                    (window.navigator as any).msSaveBlob(blob, file.file_name);
                } else {
                    let dataType = blob.type;
                    let binaryData = [];
                    binaryData.push(blob);
                    let downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(
                        new Blob(binaryData, { type: dataType })
                    );
                    if (download && file.file_name) {
                        downloadLink.download = file.file_name;
                    }
                    else{
                        downloadLink.target="_blank";
                    }
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                }
            }),
            catchError((err: Response) => {
                if (err.status === 200) {
                    console.log(err['message']);
                }
                this.openSnackBar(err['message']);
                return of(null);
            })
        )
    }


  openSnackBar(messaggio: string, duration = 1000, error: string = '') {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      data: {
        messaggio: messaggio,
        error: error
      },
      panelClass: ['mat-toolbar', 'mat-primary'],
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    });

  }

}
